import { getMethod } from '@/services/apis/http-server';
import { IIndicatorParams } from '@/interfaces/indicator';
import { removeUndefinedKeys } from '@/utils/funtion';

export const getListClientIndicator = async (params: IIndicatorParams) => {
  try {
    const response = await getMethod(`api/indicator/indicator-list`, params);
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getLastestClientIndicator = async (params: any) => {
  try {
    const response = await getMethod(
      `client/indicator/latest-indicator-list`,
      params,
    );
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getChartById = async (body: Record<string, string>) => {
  try {
    const response = await getMethod(
      `client/indicator/chart-detail-value`,
      body,
    );
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getTagsChartById = async (id: string, params: any) => {
  const newParams = removeUndefinedKeys(params);
  try {
    const response = await getMethod(
      `client/tags/chart-detail/${id}`,
      newParams,
    );
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getDetailTable = async (key: string) => {
  try {
    const response = await getMethod(`client/tags/table-detail?key=${key}`);
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getIndicatorToGenSitemap = async () => {
  try {
    const response = await getMethod(`client/indicator/sitemaps/get-all`);
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getListSlugsByScreen = async (screen: string) => {
  try {
    const response = await getMethod(`client/tags/by-screen?screen=${screen}`);
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getCompareList = async (body: any) => {
  try {
    const response = await getMethod(`client/compare-data/list`, body);
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getCompareDetail = async (body: any) => {
  const { id, ...prev } = body;
  try {
    const response = await getMethod(`client/compare-data/${id}`, prev);
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};

export const getTagsRelate = async (params: any) => {
  try {
    const response = await getMethod('client/tags/relate', params);
    return response;
  } catch (error) {
    console.error('Error fetching data from getHomeTags: ', error);
  }
};
